//	User Setings
var lineColor='#00FF40';
var fillColor='#B0FB0D';
var calloutcolor='#A00A6E';
var maptype='satellite';			//Set to 'roadmap' or 'satellite'
var NumberofDecimalPlaces=0;
var lineWeight=2;
var fillOpacity=0.5;				//From 0.0 to 1.0, where 1.0 is solid color
var showFullScreenButton = false;
var sqftmeasurementareabgcolor = '#ECFE2C'; //Background color of measurement bubble
var zoomtoaddress=21;
//	User Setings




var boolDebugMode=false;